import { api } from './client'

/**
 * F-095 (REQ-287-001): cestino delle anagrafiche. Un solo contratto per tutti i tipi:
 * `GET /api/<tipo>/trash` -> `{ total, page, pageSize, items: [{ id, label, deletedAt, deletedBy, deleteReason }] }`,
 * `POST /api/<tipo>/{id}/restore` (204; 409 se non e' nel cestino), `DELETE /api/<tipo>/{id}?reason=` (204).
 * Tutto riservato agli Admin. I Lead (F-097) e le Pratiche (F-099, `/api/contracts/trash`) usano lo stesso contratto.
 * F-104: anche Attivita' (`/api/tasks`), Appuntamenti (`/api/appointments`) e Spese (`/api/expenses`, solo spese Previste).
 */
export type TrashKind =
  | 'contacts' | 'people' | 'companies' | 'supply-points' | 'leads' | 'contracts'
  | 'tasks' | 'appointments' | 'expenses'

export const TRASH_KINDS: { kind: TrashKind; label: string }[] = [
  { kind: 'contacts', label: 'Contatti' },
  { kind: 'people', label: 'Persone' },
  { kind: 'companies', label: 'Aziende' },
  { kind: 'supply-points', label: 'Punti di fornitura' },
  { kind: 'leads', label: 'Lead' },
  { kind: 'contracts', label: 'Pratiche' },
  { kind: 'tasks', label: 'Attività' },
  { kind: 'appointments', label: 'Appuntamenti' },
  { kind: 'expenses', label: 'Spese' },
]

/**
 * F-104 (REQ-287-001): risposta di un DELETE che puo' archiviare invece di cancellare (campagne, gare, obiettivi,
 * profili agente, pipeline). `204` (nessun corpo) = rimossa davvero perche' ancora vuota; `200 { archived: true }`
 * = ha una storia, quindi e' stata archiviata e i dati collegati sono intatti.
 */
export interface ArchiveResult {
  archived?: boolean
}

export interface TrashItem {
  id: number
  label: string
  deletedAt: string
  deletedBy: number | null
  deleteReason: string | null
}

export interface TrashPage {
  total: number
  page: number
  pageSize: number
  items: TrashItem[]
}

export const trashApi = {
  list: (kind: TrashKind, p: { search?: string; page?: number; size?: number } = {}) => {
    const q = new URLSearchParams()
    if (p.search) q.set('search', p.search)
    q.set('page', String(p.page ?? 1))
    q.set('pageSize', String(p.size ?? 25))
    return api<TrashPage>(`/api/${kind}/trash?${q}`)
  },
  restore: (kind: TrashKind, id: number) => api<void>(`/api/${kind}/${id}/restore`, { method: 'POST' }),
  /** Sposta nel cestino (soft delete): il record resta in archivio e si puo' ripristinare. */
  moveToTrash: (kind: TrashKind, id: number, reason?: string) => {
    const q = reason && reason.trim() ? `?reason=${encodeURIComponent(reason.trim())}` : ''
    return api<void>(`/api/${kind}/${id}${q}`, { method: 'DELETE' })
  },
}
